import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  rabattstufeReducer,
} from '@ps20-frontend/reducers';
import { App } from '@ps20-frontend/frontend-models';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { IAppState } from './appState';
import { rootReducer } from './reducers/rootReducer.reducer';
import { rootSaga } from './sagas/rootSaga';
import { INITIAL_STATE } from './initialState';
import { selbststaendigkeitReducer } from './reducers/selbststaendigkeit.reducer';
import { rechtsstreitigkeitenReducer } from './reducers/rechtsstreitigkeitenReducer';
import { oeffentlichenDienstReducer } from './reducers/oeffentlichenDienst.reducer';
import { risikoortReducer } from './reducers/risikoort.reducer';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { vorbelegungenReducer } from './reducers/vorbelegungen.reducer';
import { adressvorschlagReducer } from './reducers/adressvorschlag.reducer';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { rsProduktReducer } from './reducers/produkt.reducer';
import { rsVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { vermieteteObjekteReducer } from './reducers/vermieteteObjekte.reducer';
import { rsTaasInfoReducer } from './reducers/rsTaasInfo.reducer';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  selbststaendigkeit: selbststaendigkeitReducer,
  imOeffentlichenDienstTaetig: oeffentlichenDienstReducer,
  rechtsstreitigkeiten: rechtsstreitigkeitenReducer,
  adressvorschlag: adressvorschlagReducer,
  risikoort: risikoortReducer,
  transientState: transientStateReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  vorbelegungen: vorbelegungenReducer,
  produkt: rsProduktReducer,
  vertragsoptionen: rsVertragsoptionenReducer,
  vermieteteObjekte: vermieteteObjekteReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.RS),
  taasInfo: rsTaasInfoReducer,
  rabattstufe: rabattstufeReducer,
  antragsnummer: antragsnummerReducer,
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  jahresbeitrag: jahresbeitragReducer,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.RS);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('rs-angebot-gui'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}
export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
